import { request } from '../../../utils/request';

interface ITokenResponse {
  access_token: string;
  expires_on: number;
  refresh_token: string;
}

const LS_TOKEN_KEY = 'hikos.analytics.pbi_token';
const LS_TOKEN_EXP_KEY = 'hikos.analytics.pbi_token_exp';

async function getNewToken() {
  const response: ITokenResponse = await request({
    url: 'power-bi',
  });

  return response;
}

export async function getAnalyticsToken() {
  const token = await getNewToken();
  localStorage.setItem(LS_TOKEN_KEY, token.access_token);
  localStorage.setItem(LS_TOKEN_EXP_KEY, String(token.expires_on * 1000));
  return {
    token: token.access_token,
    expiresIn: token.expires_on * 1000 - new Date().getTime(),
  };
}
